module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-column"
  }, [(_vm.title) ? _c('div', {
    staticClass: "flex flex-column"
  }, [_c('label', {
    staticClass: "cera-round-pro fw6 db mb3 title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.subtitle) ? _c('label', {
    staticClass: "f6 silver inter mb4"
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isOpenMessage) ? _c('br') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between responsive-email"
  }, [_c('div', {
    staticClass: "flex responsive w-100"
  }, [_c('div', {
    staticClass: "flex flex-column max-card w-50 responsive"
  }, [_c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (_vm.autoFocus),
      expression: "autoFocus"
    }],
    staticClass: "inter f6 input-reset ba db mr3 br2 code-input",
    attrs: {
      "placeholder": _vm.firstLabel,
      "maxlength": _vm.maxLength
    },
    domProps: {
      "value": _vm.firstValue
    },
    on: {
      "input": _vm.setFirstValue
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column w-50 responsive"
  }, [_c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (_vm.autoFocus),
      expression: "autoFocus"
    }],
    staticClass: "inter f6 input-reset ba db br2 code-input responsive-last",
    attrs: {
      "placeholder": _vm.secondLabel,
      "maxlength": _vm.maxLength
    },
    domProps: {
      "value": _vm.secondValue
    },
    on: {
      "input": _vm.setSecondValue
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex responsive w-100"
  }, [_c('div', {
    staticClass: "flex flex-column max-card w-50 responsive"
  }, [_c('input', {
    staticClass: "inter f6 input-reset ba db br2 mr3 code-input",
    attrs: {
      "placeholder": _vm.thirdLabel
    },
    domProps: {
      "value": _vm.thirdValue
    },
    on: {
      "input": _vm.setThirdValue,
      "focus": function($event) {
        return _vm.emailInput(false)
      },
      "blur": function($event) {
        return _vm.emailInput(true)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "color-theme f6 mt2 w-100 mb2",
    class: _vm.showEmailError ? '' : 'invisible'
  }, [_vm._v("\n        " + _vm._s(_vm.emailError ? 'Please enter a valid email' : "Student's Email (use .edu address)") + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column w-50 responsive"
  }, [_c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (_vm.autoFocus),
      expression: "autoFocus"
    }],
    staticClass: "inter f6 input-reset ba db br2 code-input responsive-last",
    attrs: {
      "placeholder": _vm.fourthLabel,
      "maxlength": _vm.maxLength
    },
    domProps: {
      "value": _vm.fourthValue
    },
    on: {
      "input": _vm.setFourthValue
    }
  })])])]), _vm._v(" "), (_vm.showStudentMessage) ? _c('div', {
    staticClass: "f6 silver inter mt4 mb2"
  }, [_vm._v("\n    If you do not have a .edu email, enter an alternate email address.\n    "), _c('br'), _vm._v(" \n    You will need to provide verification of student status.\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7020f56e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/forms/PersonalFormCheckout.vue
// module id = 777
// module chunks = 0